import React from 'react'
import { Select, Modal } from 'hljd'
import _toString from 'lodash/toString'

const Option = Select.Option
const confirm = Modal.confirm

export default store => {
  const deleteGoods = id => {
    confirm({
      title: '确认要删除该商品吗',
      okText: '确定',
      cancelText: '取消',
      onOk() {
        store.deleteSetMeal(id)
      },
      onCancel() {}
    })
  }
  return [
    {
      title: '商品名称',
      dataIndex: 'title',
      key: 'title',
      width: 280,
      render: (
        text,
        { id, cover_path, hot_tag = '0', property_id, is_sold_out, status }
      ) => {
        return (
          <div className="table-title">
            <div className="table-title-left">
              <img
                src={cover_path}
                style={{ width: '100px', height: '62px', display: 'block' }}
              />
              <Select
                value={_toString(hot_tag)}
                onChange={value => store.changeHotTag(id, value, property_id)}
                style={{ width: 100, marginTop: '10px' }}
              >
                <Option value="0">请选择商品热标</Option>
                <Option value="3">超值特价</Option>
                <Option value="2">本季热卖</Option>
                <Option value="1">人气推荐</Option>
              </Select>
            </div>
            <div className="table-title-right">
              {status == 3 || is_sold_out == true ? (
                <a>{text}</a>
              ) : (
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={
                    '/p/wedding/Web/Detail/detail/type/package/id/' +
                    id +
                    '/admin/true'
                  }
                >
                  {text}
                </a>
              )}
            </div>
          </div>
        )
      }
    },
    {
      title: '商品类型',
      key: 'is_from_direct_supply',
      dataIndex: 'is_from_direct_supply',
      width: 126,
      render: (is_from_direct_supply = 0) => {
        if (is_from_direct_supply == '0') {
          return <span>自有</span>
        } else {
          return <span style={{ color: '#FF8C30' }}>婚礼纪直供</span>
        }
      }
    },
    {
      title: '价格',
      key: 'actual_price',
      dataIndex: 'actual_price',
      width: 126,
      render: actual_price => {
        return <span>￥{actual_price}</span>
      }
    },
    {
      title: '售出数',
      key: 'sales_count',
      dataIndex: 'sales_count',
      width: 100
    },
    {
      title: '收藏数',
      key: 'collectors_count',
      dataIndex: 'collectors_count',
      width: 100
    },
    {
      title: '上架时间',
      key: 'updated_at',
      dataIndex: 'updated_at',
      width: 100
    },
    {
      title: '操作',
      key: 'operate',
      dataIndex: 'operate',
      width: 80,
      render: (
        text,
        {
          is_from_direct_supply = 0,
          id,
          is_sold_out,
          rule,
          second_category_id,
          property_id
        }
      ) => {
        return (
          <div className="table-operate">
            {is_from_direct_supply == '0' ? (
              <div>
                <span
                  className="edit"
                  onClick={() =>
                    store.setMealEditFn(
                      id,
                      rule,
                      second_category_id,
                      property_id
                    )
                  }
                >
                  编辑
                </span>
              </div>
            ) : null}
            {is_from_direct_supply == '0' ? (
              <div>
                <span
                  className="cancel"
                  onClick={() => store.SoldOutGood(id, is_sold_out)}
                >
                  {is_sold_out == 0 ? '下架' : '上架'}
                </span>
              </div>
            ) : null}
            <div>
              <span className="delete" onClick={() => deleteGoods(id)}>
                删除
              </span>
            </div>
          </div>
        )
      }
    },
    {
      title: '排序',
      key: 'sort',
      dataIndex: 'sort',
      width: 150,
      render: (text, record, index) => {
        return (
          <div className="table-sort">
            <button
              disabled={index == 0}
              onClick={() => store.orderFn(record.id, index, 'up')}
              className={index == 0 ? 'disabled' : ''}
            />
            <button
              disabled={index == store.listLen - 1 || store.listLen == 1}
              onClick={() => store.orderFn(record.id, index, 'down')}
              className={
                index == store.listLen - 1 || store.listLen == 1
                  ? 'disabled'
                  : ''
              }
            />
            <button
              disabled={index == 0}
              onClick={() => store.orderTop(record.id)}
              className={index == 0 ? 'disabled' : ''}
            />
          </div>
        )
      }
    }
  ]
}
